exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.badge-list {\n  pointer-events: none;\n  position: absolute;\n  display: grid;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align:start;\n      align-items:start;\n  grid-template-rows: 1fr 1fr 1fr;\n  grid-template-columns: 1fr 1fr 1fr;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n}", ""]);

// exports
